import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaExpandedSDK } from './types';
import { assert } from '../../assert';

const expandedSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaExpandedSDK
> = ({ setProps, props }) => ({
  get expanded() {
    return props.ariaAttributes?.expanded;
  },

  set expanded(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        expanded: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createExpandedSDK = withValidation(expandedSDKFactory, {
  type: ['object'],
  properties: {
    expanded: {
      type: ['boolean', 'string'],
      enum: ['false', 'true'],
    },
  },
});
